(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["suite365-growth"] && !Shopify.designMode) return;
  try {
    (() => {
    if(window.suite365GrowthEventsReady)return;window.suite365GrowthEventsReady=true;
    function publish(name, data) {
      const shop = window.Shopify;
      if (!shop?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
      if (typeof shop.analytics?.publish !== 'function') return;
      Promise.resolve(shop.analytics.publish('suite365:' + name, data)).catch(() => {});
    }
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-s365-event]');
      if (link) publish(link.dataset.s365Event, {placement:link.dataset.placement || 'page'});
    });
    const errorSummary = document.querySelector('[data-s365-errors]');
    if (errorSummary) errorSummary.focus();
    document.querySelectorAll('[data-s365-success]').forEach(el => {
      publish('form_success', {form_kind:el.dataset.s365Success});
      el.focus({preventScroll:true});
    });
    window.addEventListener('suite365:selection', event => {
      const d=event.detail;
      publish('product_selection', {product_key:d.product, size:d.size, color:d.color});
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
